import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";
import { DatePicker } from "@mui/x-date-pickers";
import { Fragment, useEffect, useRef, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale";
import { format, isValid, set } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  downloadCSVFile,
  downloadExcelFile,
  downloadInvoiceFile,
  getActiveReportEnabledCustomers,
  getCurrency,
  getCustomerByID,
  getCustomerStaticDataByCustID,
  getTicketReport,
} from "../redux/actions/AdminAction";
import {
  GET_CUSTOMER_RESET,
  GET_CUSTOMER_STATIC_DATA_RESET,
  GET_TICKET_REPORT_RESET,
} from "../Constants/Constants";
import { LoadingButton } from "@mui/lab";
import CircularProgressWithLabel from "../Components/CircularProgressWithLabel";
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from "@mui/material/useMediaQuery";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(10),
    border: "1px solid #dadde9",
  },
}));

const formatFormOfPaymentLabel = (value) =>
  value === "Credit" ? "Credit Card" : value;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 5,
  textAlign: "center",
};

function createData(
  ticket_number,
  ticket_status,
  name,
  date,
  fare,
  taxes,
  pnr,
  currency,
  fop
) {
  return {
    ticket_number,
    ticket_status,
    name,
    date,
    fare,
    taxes,
    pnr,
    currency,
    fop,
  };
}

export default function TicketReport(props) {
  const { decodedToken, checkUserPermission } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(max-width:1869px)");
  const isMediumScreen = useMediaQuery("(max-width:1800px)"); // For tablet responsiveness
  const isSmallScreen = useMediaQuery("(max-width:1500px)");
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const ticketStatusFilter = ["ALL", "VENTE", "VOID", "REFUND"];
  const formOfPaymentFilter = [
    "ALL",
    "CASH",
    "CHECK",
    "Credit",
    "MiscFormOfPayment",
  ];

  const [row, setRow] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [infoAlert, setInfoAlert] = useState(false);
  const [infoAlertMessage, setInfoAlertMessage] = useState("");
  const [selected_pcc, setSelected_pcc] = useState(null);
  const [PCCs, setPCCs] = useState([]);
  const [date_range, setDate_range] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [totalFares, setTotalFares] = useState(null);
  const [totalTaxes, setTotalTaxes] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [totalComm, setTotalComm] = useState(null);
  const [currencies, setCurrencies] = useState({ default: "Default" });
  const [currency, setCurrency] = useState("default");
  const [response_currency, setRespose_currency] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [apiResponseTime, setApiResponseTime] = useState(0);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [ticketReportInfo, setTicketReportInfo] = useState(null);
  const [selectedTicketStatusFilter, setSelectTicketStatusFilter] =
    useState("ALL");
  const [selectedFormOfPaymentFilter, setSelectFormOfPaymentFilter] =
    useState("ALL");
  const [customer_id, setCustomer_id] = useState(null);
  const [customer_name, setCustomer_name] = useState(null);
  const [xlsxLoading, setXlsxLoading] = useState(false);
  const [xlsLoading, setXlsLoading] = useState(false);
  const [reportType, setReportType] = useState("g");
  const [iata_number, setIata_number] = useState(null);
  const [query_date_time, setQuery_date_time] = useState(null);
  const [totalIssuedTicket, setTotalIssuedTicket] = useState(null);
  const [totalRefundTicket, setTotalRefundTicket] = useState(null);
  const [customerCountry, setCustomerCountry] = useState(null);
  const tableRef = useRef(null);

  const GetAllActiveReportEnabledCustomers = useSelector(
    (state) => state.GetAllActiveReportEnabledCustomers
  );
  const { activeReportEnabledCustomersInfo } =
    GetAllActiveReportEnabledCustomers;

  const GetCustomerByID = useSelector((state) => state.GetCustomerByID);
  const { customerById } = GetCustomerByID;

  const GetTicketReportData = useSelector((state) => state.GetTicketReportData);
  const { ticketReportData, loading } = GetTicketReportData;

  const GetCurrency = useSelector((state) => state.GetCurrency);
  const { currencyInfo } = GetCurrency;

  const DownloadExcelFile = useSelector((state) => state.DownloadExcelFile);
  const { downloadExcelLoading } = DownloadExcelFile;

  const DownloadCSVFile = useSelector((state) => state.DownloadCSVFile);
  const { downloadCSVLoading } = DownloadCSVFile;
  // const [xlsxLoading, setXlsxLoading] = useState(false);
  const {
    invoiceData,
    invoiceLoading,
    invoiceError,
  } = useSelector((state) => state.InvoiceDisplay);

  const [openInvoiceModel, setOpenInvoiceModel] = useState(false);

  useEffect(() => {
    if (invoiceData) {
      setLoadingRowId(null);
      setOpenInvoiceModel(true);
    }
  }, [invoiceData]);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const GetCustomerStaticDataByCustID = useSelector(
    (state) => state.GetCustomerStaticDataByCustID
  );
  const { customerStaticDataInfo } = GetCustomerStaticDataByCustID;

  useEffect(() => {
    if (ticketReportData) {
      setTicketReportInfo(ticketReportData);
    }
  }, [ticketReportData]);

  useEffect(() => {
    setReportType("g");
    dispatch(getCustomerStaticDataByCustID(customer_id));
  }, [customer_id]);

  useEffect(() => {
    if (
      reportGenerated &&
      (!ticketReportData || Object.keys(ticketReportData).length === 0)
    ) {
      setInfoAlertMessage(
        "Oops! No data available for the selected date range or currency. Please try adjusting your dates or currency and search again."
      );
      setSnackOpen(true);
      setInfoAlert(true);
      setReportGenerated(false);
    }
  }, [reportGenerated]);

  useEffect(() => {
    if (ticketReportInfo) {
      const clonedTicketReportData = JSON.parse(
        JSON.stringify(ticketReportInfo)
      );

      if (selectedTicketStatusFilter == "ALL") {
        const issuedTickets = clonedTicketReportData.filter(
          (ticket) => ticket.transaction === "VENTE"
        );

        const refundTickets = clonedTicketReportData.filter(
          (ticket) => ticket.transaction === "REFUND"
        );

        const totalIssued = issuedTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const totalRefund = refundTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        setTotalIssuedTicket(totalIssued);
        setTotalRefundTicket(totalRefund);
      }

      if (Object.values(ticketReportInfo).length > 0 && apiResponseTime > 0) {
        const newRows = clonedTicketReportData.map((value) => {
          return createData(
            value.number,
            value.transaction,
            value.traveler_name,
            value.ticket_date,
            value.ht,
            value.total_taxe,
            value.pnr,
            value.device,
            value.formOfPayment
          );
        });
        setRow(newRows);

        if (currency === "default") {
          const res_currency = Object.values(clonedTicketReportData)?.find(
            (item) => item?.device
          )?.device;
          setRespose_currency(res_currency);
        }

        const totalFares = clonedTicketReportData
          .reduce((acc, item) => {
            const ht = Number(item?.ht) || 0;
            return acc + parseFloat(ht);
          }, 0)
          .toFixed(2);

        const totalTaxes = clonedTicketReportData
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            return acc + parseFloat(taxes);
          }, 0)
          .toFixed(2);

        const totalAmount = clonedTicketReportData
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const iata = clonedTicketReportData.find(
          (item) => item?.iata_number
        )?.iata_number;

        const totalComm = clonedTicketReportData
          .reduce((acc, item) => {
            const comm = Number(item?.commission) || 0;
            return acc + parseFloat(comm);
          }, 0)
          .toFixed(2);

        setTotalFares(totalFares);
        setTotalTaxes(totalTaxes);
        setTotalAmount(totalAmount);
        setIata_number(iata);
        setTotalComm(totalComm);

        setTimeout(() => {
          if (tableRef.current) {
            tableRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 100);
      } else {
        setTotalFares("0.00");
        setTotalTaxes("0.00");
        setTotalAmount("0.00");
      }
    }
  }, [ticketReportInfo, apiResponseTime]);

  useEffect(() => {
    dispatch({ type: GET_CUSTOMER_RESET });
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_RESET });
  }, []);

  useEffect(() => {
    if (loading) {
      // setProgress(0);
      setOpenModal(true);

      const startTime = Date.now();

      const timer = setInterval(() => {
        const elapsedTime = Date.now() - startTime;

        const percentProgress =
          apiResponseTime > 0
            ? Math.min((elapsedTime / apiResponseTime) * 100, 100)
            : Math.min(elapsedTime / 100, 90);
        setProgress(percentProgress);

        if (percentProgress >= 100) {
          clearInterval(timer);
        }
      }, 100);

      return () => {
        clearInterval(timer);
        setProgress(0);
      };
    }
  }, [loading, apiResponseTime]);

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    if (!checkUserPermission(103, "can_view")) {
      navigate("/");
      return;
    }

    // Only dispatch actions if token and permissions are valid
    dispatch(getActiveReportEnabledCustomers());
    dispatch(getCurrency());
  }, [dispatch, token, navigate, checkUserPermission]);

  useEffect(() => {
    if (customerById) {
      if (Object.values(customerById).length == 1) {
        setCustomer_name(customerById[0]?.customer_name?.trim());
      }
      const pcc = customerById?.pccs?.trim()?.split(" ");
      setPCCs(pcc);

      if (pcc && pcc.length == 1) {
        setSelected_pcc(pcc[0]);
      }
      const country = customerById?.country?.trim();
      setCustomerCountry(country);
    }
  }, [customerById, selected_pcc]);

  useEffect(() => {
    if (currencyInfo) {
      setCurrencies((prevState) => ({ ...prevState, ...currencyInfo }));
      setCurrency("default");
    }
  }, [currencyInfo]);

  useEffect(() => {
    const filterTickets = () => {
      let filteredTickets =
        (ticketReportInfo && JSON.parse(JSON.stringify(ticketReportData))) ||
        [];

      if (
        selectedTicketStatusFilter === "ALL" &&
        selectedFormOfPaymentFilter === "ALL"
      ) {
        setTicketReportInfo(ticketReportData);
        const newRows =
          ticketReportData &&
          ticketReportData.map((value) => {
            return createData(
              value.number,
              value.transaction,
              value.traveler_name,
              value.ticket_date,
              value.ht,
              value.total_taxe,
              value.pnr,
              value.device,
              value.formOfPayment
            );
          });
        setRow(newRows);
        return;
      }

      if (selectedTicketStatusFilter == "ALL") {
        const issuedTickets = ticketReportData.filter(
          (ticket) => ticket.transaction === "VENTE"
        );

        const refundTickets = ticketReportData.filter(
          (ticket) => ticket.transaction === "REFUND"
        );

        const totalIssued = issuedTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const totalRefund = refundTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        setTotalIssuedTicket(totalIssued);
        setTotalRefundTicket(totalRefund);
      }

      // Filter by ticket status
      if (selectedTicketStatusFilter !== "ALL") {
        filteredTickets = filteredTickets.filter(
          (ticket) => ticket.transaction === selectedTicketStatusFilter
        );
        setTotalIssuedTicket(null);
        setTotalRefundTicket(null);
      }

      // Filter by form of payment
      if (selectedFormOfPaymentFilter !== "ALL") {
        filteredTickets = filteredTickets.filter(
          (ticket) => ticket.formOfPayment === selectedFormOfPaymentFilter
        );
      }

      const newRows =
        filteredTickets &&
        filteredTickets.map((value) => {
          return createData(
            value.number,
            value.transaction,
            value.traveler_name,
            value.ticket_date,
            value.ht,
            value.total_taxe,
            value.pnr,
            value.device,
            value.formOfPayment
          );
        });
      setRow(newRows);
      setTicketReportInfo(filteredTickets);
    };

    filterTickets();
  }, [selectedTicketStatusFilter, selectedFormOfPaymentFilter]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  const handleDateRangeChange = (ranges) => {
    if (ranges && ranges.selection) {
      const { startDate, endDate } = ranges.selection;

      if (startDate && endDate && isValid(startDate) && isValid(endDate)) {
        // Check the difference between startDate and endDate (7 days max)
        const daysDifference = (endDate - startDate) / (1000 * 3600 * 24);

        if (daysDifference <= 15) {
          setDate_range({
            startDate,
            endDate,
            key: "selection",
          });
        } else {
          setErrorAlertTitle("Error!");
          setErrorAlertMessage("You can only select a maximum of 16 days.");
          setSnackOpen(true);
          setErrorAlert(true);
        }
      }
    }
  };

  const handleCSVDownload = (reportType) => {
    if (Object.keys(ticketReportInfo).length > 0) {
      const request_data = {
        iata_number: iata_number || "",
        ticketReportInfo: ticketReportInfo,
        total_fares: totalFares || "",
        total_taxes: totalTaxes || "",
        total_amount: totalAmount || "",
        total_comm: totalComm || "",
        currency: currency !== "default" ? currency : response_currency,
        query_date_time: query_date_time || "",
        total_issued_ticket: totalIssuedTicket || "",
        total_refund_ticket: totalRefundTicket || "",
      };
      dispatch(downloadCSVFile(customer_name, request_data, reportType));
    } else {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  const handleExcelDownload = (fileType, reportType) => {
    if (Object.keys(ticketReportInfo).length > 0) {
      if (fileType === "xlsx") {
        setXlsxLoading(true);
      } else if (fileType === "xls") {
        setXlsLoading(true);
      }

      const request_data = {
        iata_number: iata_number || "",
        ticketReportInfo: ticketReportInfo,
        total_fares: totalFares || "",
        total_taxes: totalTaxes || "",
        total_amount: totalAmount || "",
        total_comm: totalComm || "",
        currency: currency !== "default" ? currency : response_currency,
        query_date_time: query_date_time || "",
        total_issued_ticket: totalIssuedTicket || "",
        total_refund_ticket: totalRefundTicket || "",
      };

      dispatch(
        downloadExcelFile(customer_name, request_data, reportType, fileType)
      )
        .then(() => {
          // Reset loading state on success
          if (fileType === "xlsx") {
            setXlsxLoading(false);
          } else if (fileType === "xls") {
            setXlsLoading(false);
          }
        })
        .catch(() => {
          // Reset loading state on error
          if (fileType === "xlsx") {
            setXlsxLoading(false);
          } else if (fileType === "xls") {
            setXlsLoading(false);
          }
        });
    } else {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };
  const handleInvoiceDownload = (fileType, row) => {
    if (!row || !row.ticket_number) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invalid row data!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    // 🔎 Find the full object from main array
    const selectedTicket = ticketReportInfo.find(
      (item) =>
        item.number === row.ticket_number
    );

    if (!selectedTicket) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Ticket details not found!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }
    setLoadingRowId(row.ticket_number);

    const request_data = {
      pcc_code: selected_pcc || "",
      data: selectedTicket, // ✅ full object only
    };

    if (fileType === "xlsx") setXlsxLoading(true);
    if (fileType === "xls") setXlsLoading(true);

    dispatch(downloadInvoiceFile(request_data))
      .finally(() => {
        if (fileType === "xlsx") setXlsxLoading(false);
        if (fileType === "xls") setXlsLoading(false);
      });
  };

  const handleReportType = (event) => {
    setReportType(event.target.value);
  };

  const submitHandler = () => {
    setProgress(0);
    setApiResponseTime(0);
    setRow(null);
    dispatch({ type: GET_TICKET_REPORT_RESET });
    setReportGenerated(false);

    const { startDate, endDate } = date_range;
    if (!selected_pcc) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage(
        "Please choose the name of the customer, the relevant PCC and currency, if the customer has more than one PCC or currency."
      );
      setSnackOpen(true);
      setErrorAlert(true);
      setReportGenerated(false);
      return;
    }

    if (!startDate && !endDate) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Select the date range.");
      setSnackOpen(true);
      setErrorAlert(true);
      setReportGenerated(false);
      return;
    }

    const query_start = format(startDate, "ddMMMyy").toUpperCase();
    const query_end = format(endDate, "ddMMMyy").toUpperCase();
    setQuery_date_time(`${query_start}-${query_end}`);

    const formattedStartDate = format(startDate, "ddMMM").toUpperCase();
    const formattedEndDate = format(endDate, "ddMMM").toUpperCase();
    let command =
      currency !== "default"
        ? `HMPP/CU-${currency}/${formattedStartDate}-${formattedEndDate}`
        : `HMPP/${formattedStartDate}-${formattedEndDate}`;

    if (selected_pcc && command) {
      const startTime = performance.now();

      dispatch(
        getTicketReport(customer_id, selected_pcc, command, reportType)
      ).then(() => {
        const endTime = performance.now();
        const responseTime = endTime - startTime;
        setApiResponseTime(responseTime);
        setReportGenerated(true);
      });
    }
  };

  return (
    <Box sx={{ marginBottom: "5%" }}>
      <Container
        sx={{
          width: "100%",
          marginBottom: "5%",
          justifyContent: "center",
        }}
      >
        <Box sx={{ margin: 3, fontSize: 25, textAlign: "center" }}>
          Ticket Report
          <Divider sx={{ marginTop: 2 }}></Divider>
        </Box>
        <Grid
          container
          mt={1}
          sx={{
            // backgroundColor: "#E0E0EC",
            padding: 2,
            borderRadius: 2,
            // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid xs={4} mt={2}>
            <Typography>Customer Name</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>PCC</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>Currency</Typography>
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              options={
                (activeReportEnabledCustomersInfo &&
                  Object.values(activeReportEnabledCustomersInfo)) ||
                []
              }
              getOptionLabel={(option) => option?.customer_name?.trim() || ""}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  dispatch(getCustomerByID(values.customer_id));
                  setCustomer_id(values.customer_id);
                  setCustomer_name(values.customer_name?.trim());
                } else {
                  dispatch({ type: GET_CUSTOMER_RESET });
                  setSelected_pcc(null);
                }
              }}
            />
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={selected_pcc || null}
              options={(PCCs && Object.values(PCCs)) || []}
              getOptionLabel={(options) => options}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  setSelected_pcc(values);
                } else {
                  setSelected_pcc(null);
                }
              }}
            />
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={
                currency === "default"
                  ? { 0: "default", 1: "Default" }
                  : { 0: currency, 1: currencies[currency] }
              }
              options={(currencies && Object.entries(currencies)) || []}
              getOptionLabel={(options) => {
                if (options[0] === "default") {
                  return "Default";
                }
                return `${options[0]} - ${options[1]}`;
              }}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  setCurrency(values[0]);
                } else {
                  setCurrency("default");
                }
              }}
            />
          </Grid>
          {customerStaticDataInfo === undefined ? (
            <Grid item xs={12} mt={3}>
              <FormControl>
                <RadioGroup
                  row
                  defaultValue={reportType}
                  value={reportType}
                  onChange={handleReportType}
                >
                  <FormControlLabel
                    value="g"
                    control={<Radio />}
                    label="General Ticket Report"
                  />
                  <FormControlLabel
                    value="c"
                    control={<Radio />}
                    label="Advanced Ticket Report"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}
          <Grid xs={12} mt={3}>
            Please choose your Date Range
          </Grid>
          <Grid xs={12} mt={2}>
            <DateRangePicker
              ranges={[date_range]}
              locale={enUS}
              maxDate={new Date()}
              minDate={new Date(new Date().setMonth(new Date().getMonth() - 6))}
              onChange={handleDateRangeChange}
              editableDateInputs={true}
              rangeColors={["black"]}
            />
          </Grid>
          <Grid xs={12} mt={2} sx={{ color: "red" }}>
            Please note that ticket report is allowed to generate only for 16
            days.
          </Grid>
          <Grid xs={12} mt={3} mb={1}>
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              onClick={submitHandler}
              variant="contained"
              type="submit"
              sx={{ backgroundColor: "#282828", width: "20%" }}
            >
              Generate Report
            </LoadingButton>
          </Grid>
        </Grid>
      </Container>

      {/* Ticket Report Data List */}
      {loading ? (
        <Modal open={openModal}>
          <Box sx={modalStyle}>
            <Grid container>
              <Grid xs={12}>
                <CircularProgress />
              </Grid>
              <Grid xs={12} mt={3} md={0}>
                <Typography>
                  Just a moment, we're preparing everything for you.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      ) : row ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          ref={tableRef}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // textAlign: "center",
              // width: "70%",
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "left",
              }}
            >
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
                options={ticketStatusFilter || []}
                value={selectedTicketStatusFilter || null}
                getOptionLabel={(options) => options}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Ticket Status"
                    />
                  );
                }}
                onChange={(e, values) => {
                  if (values) {
                    setSelectTicketStatusFilter(values);
                  }
                }}
              />
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "50%" : isMediumScreen ? "40%" : "35%",
                  marginLeft: 3,
                }}
                value={selectedFormOfPaymentFilter || null}
                options={formOfPaymentFilter || []}
                getOptionLabel={(options) => formatFormOfPaymentLabel(options)}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Form Of Payment"
                    />
                  );
                }}
                onChange={(e, values) => {
                  if (values) {
                    if (values != "ALL") {
                      let formattedValue;
                      if (values === "MiscFormOfPayment") {
                        formattedValue = values;
                      } else if (values === "Credit") {
                        formattedValue = values;
                      } else {
                        formattedValue =
                          values.charAt(0).toUpperCase() +
                          values.slice(1).toLowerCase();
                      }
                      setSelectFormOfPaymentFilter(formattedValue);
                    } else {
                      setSelectFormOfPaymentFilter(values);
                    }
                  }
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "right",
              }}
            >
              <LoadingButton
                loading={xlsxLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xlsx", reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
              >
                Download .xlsx
              </LoadingButton>
              <LoadingButton
                loading={xlsLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xls", reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download .xls
              </LoadingButton>
              <LoadingButton
                loading={downloadCSVLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleCSVDownload(reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download CSV
              </LoadingButton>
              <HtmlTooltip
                title={
                  <Fragment>
                    <Typography sx={{ fontWeight: "bold" }}>
                      This setting only takes effect after downloading the Excel
                      file.
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Web Excel
                    </Typography>
                    <Typography>- Select File</Typography>
                    <Typography>- Select Options</Typography>
                    <Typography>- Select Regional Settings</Typography>
                    <Typography>
                      - Select a region from the drop-down list
                    </Typography>
                    <Typography>- Select Change</Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Windows
                    </Typography>
                    <Typography>- Select the Start button</Typography>
                    <Typography>- Select Settings</Typography>
                    <Typography>- Select Time & language</Typography>
                    <Typography>- Select Region</Typography>
                    <Typography>
                      - Select Change date, time, or number formats
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      If your date format is already set to DD/MM/YYYY, you can
                      ignore these instructions.
                    </Typography>
                  </Fragment>
                }
                arrow
              >
                <LiveHelpIcon
                  fontSize="large"
                  sx={{ color: "red", marginLeft: 2 }}
                />
              </HtmlTooltip>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: 3,
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 3,
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Total Fares</StyledTableCell>
                    <StyledTableCell>Total Taxes</StyledTableCell>
                    <StyledTableCell>Total Amount</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableCell>
                    {currency !== "default" ? currency : response_currency}
                  </StyledTableCell>
                  <StyledTableCell>{totalFares}</StyledTableCell>
                  <StyledTableCell>{totalTaxes}</StyledTableCell>
                  <StyledTableCell>{totalAmount}</StyledTableCell>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
              marginTop: 3,
            }}
          >
            <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>PNR</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Ticket Number</StyledTableCell>
                    <StyledTableCell>Fare</StyledTableCell>
                    <StyledTableCell>Taxes</StyledTableCell>
                    <StyledTableCell>Ticket Status</StyledTableCell>
                    <StyledTableCell>FOP</StyledTableCell>
                    <StyledTableCell>Currency</StyledTableCell>
                    {/* <StyledTableCell>Invoice</StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.length > 0 ? (
                    row.map((row) => (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {row.date}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.pnr}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.name.trim()}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.ticket_number}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.fare}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.taxes}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.ticket_status}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {formatFormOfPaymentLabel(row.fop)}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.currency}
                        </StyledTableCell>
                        {/* <StyledTableCell component="th" scope="row">
                          <LoadingButton
                            loading={loadingRowId === row.ticket_number}
                            loadingIndicator="Preparing..."
                            onClick={() => handleInvoiceDownload("pdf", row)}
                            variant="contained"
                            sx={{
                              backgroundColor: "#282828",
                              width: "80%",
                              marginLeft: 3,
                            }}
                          >
                            View Invoice
                          </LoadingButton>
                        </StyledTableCell> */}

                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      <StyledTableCell
                        component="th"
                        colSpan={9}
                        scope="row"
                        style={{
                          textAlign: "center",
                          wordWrap: "break-word",
                          maxWidth: "100%",
                          fontSize: 15,
                        }}
                      >
                        No data found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      ) : null}

      {errorAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            <AlertTitle>{errorAlertTitle}</AlertTitle>
            {errorAlertMessage}
          </Alert>
        </Snackbar>
      )}
      {infoAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="info"
            sx={{ width: "100%" }}
          >
            {/* <AlertTitle>{errorAlertTitle}</AlertTitle> */}
            {infoAlertMessage}
          </Alert>
        </Snackbar>
      )}
      <Dialog open={openInvoiceModel} onClose={() => setOpenInvoiceModel(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          Invoice Preview
          <IconButton
            onClick={() => setOpenInvoiceModel(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ height: "75vh" }}>
          {invoiceData && !invoiceError && (
            <object
              data={invoiceData.fileUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            />

          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              const link = document.createElement("a");
              link.href = invoiceData.fileUrl;
              link.download = invoiceData.fileName;
              link.click();
            }}
          >
            Download Invoice
          </Button>

          <Button variant="outlined" onClick={() => setOpenInvoiceModel(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}
